import { get } from '~/utils/ajax'

import { Installment, Shop } from './contracts'

export * from './contracts'

export const getShops = () => get<Shop[]>('dictionary/shop')

export const getInstallments = () => get<Installment[]>('dictionary/installment')
